"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_PAYLOAD_CLASSES = exports.TIPO_DE_SERVICIO = exports.ESTATUS_SERVICIO = exports.ESTATUS_ACTIVIDAD = void 0;
__exportStar(require("./auth"), exports);
__exportStar(require("./cdr-bloqueo-saliente"), exports);
__exportStar(require("./cdr-saliente-contestadas"), exports);
__exportStar(require("./cdr-saliente-fallidas"), exports);
__exportStar(require("./cliente"), exports);
__exportStar(require("./clientes-cdr"), exports);
__exportStar(require("./consolidado-saliente-sms"), exports);
__exportStar(require("./dbuserin"), exports);
__exportStar(require("./dbuserout"), exports);
__exportStar(require("./group-senders"), exports);
__exportStar(require("./grupo-num"), exports);
__exportStar(require("./historial-bloq-1"), exports);
__exportStar(require("./log-reporte-csv-bloq"), exports);
__exportStar(require("./mfa"), exports);
__exportStar(require("./numeracion"), exports);
__exportStar(require("./pool-senders"), exports);
__exportStar(require("./requerimientos"), exports);
__exportStar(require("./show-ani"), exports);
__exportStar(require("./show-bloq"), exports);
__exportStar(require("./sms-asignacion"), exports);
__exportStar(require("./sms-campania"), exports);
__exportStar(require("./sms-colas"), exports);
__exportStar(require("./sms-saliente"), exports);
__exportStar(require("./smsout-view"), exports);
__exportStar(require("./tarifas-maquina-virtual"), exports);
__exportStar(require("./tarifas-sms-ng"), exports);
__exportStar(require("./tbl-did"), exports);
__exportStar(require("./telco"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./view-asociados"), exports);
__exportStar(require("./view-recibidos"), exports);
__exportStar(require("./view-status-camp"), exports);
// itop
__exportStar(require("./itop/index"), exports);
exports.ESTATUS_ACTIVIDAD = {
    INACTIVO: 0,
    ACTIVO: 1,
};
exports.ESTATUS_SERVICIO = {
    INACTIVO: 0,
    ACTIVO: 1,
    PENDIENTE: 2,
};
exports.TIPO_DE_SERVICIO = {
    HOUSING: 1,
    MAQUINA_VIRTUAL: 2,
    INTERNET: 3,
    ENLACE: 4,
    TIC: 5,
    TELEFONIA_NACIONAL: 6,
    TELEFONIA_INTERNACIONAL: 7,
    SMS: 8,
    DID: 9,
    'SMS NG': 10,
};
exports.ITOP_PAYLOAD_CLASSES = {
    ATTACHMENT: 'Attachment',
    INCIDENT: 'Incident',
    USER_REQUEST: 'UserRequest',
};
